'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (img) {
  // in product list
  if ($productListItem.length > 0) {
    calculate(img, '.p-l__item', '.p-l-i__figure', '.product-list');
  }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $productListItem = (0, _jquery2.default)('.p-l__item', document);
var itemObj = {};

function calculate(img, itemWrapClass, imageWrapClass, wrapAll) {
  var $wrap = (0, _jquery2.default)(img).closest(itemWrapClass);
  var $wrapAll = (0, _jquery2.default)(wrapAll);
  var index = $wrap.index();
  var itemsCount = Math.round($wrapAll.width() / (0, _jquery2.default)(itemWrapClass).outerWidth());
  var $item = (0, _jquery2.default)(itemWrapClass, $wrapAll);
  var lastItemsCount = $item.length % itemsCount;

  // for right
  (0, _jquery2.default)(img).addClass('img-loaded');

  var minNumb = index - index % itemsCount;

  itemObj[minNumb] = isNaN(itemObj[minNumb]) ? 1 : itemObj[minNumb] + 1;

  // all images in row is loaded!
  var allImgInRowIsLoaded = itemObj[minNumb] === itemsCount;
  // last items is load
  var lastImgInRowIsLoaded = itemObj[minNumb] === lastItemsCount && index + 1 > $item.length - lastItemsCount;

  if (allImgInRowIsLoaded || lastImgInRowIsLoaded) {
    var maxHeight = 0;

    // get top height
    for (var i = minNumb; i < minNumb + itemsCount; ++i) {
      var thisImgHeight = $item.eq(i).find('.img-loaded').height();

      if (maxHeight < thisImgHeight) {
        maxHeight = thisImgHeight;
      }
    }

    // set height
    for (var i = minNumb; i < minNumb + itemsCount; ++i) {
      $item.eq(i).find(imageWrapClass).css('height', maxHeight);
    }

    // reset number in case switch pages
    itemObj[minNumb] = 1;
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/modules/boxHeight.js
// module id = 402
// module chunks = 0 1